export default {
    ADDING: "Добавление объекта на карту",
    ADD_LOCATION_POINT: "Добавить метку",
    ADD_LINE: "Добавить линию",
    ADD_AREA: "Добавить область",
    DELETING: "Удаление",
    DELETE_OBJECT: "Удалить объект",
    DELETE_OBJECT_HINT: "Shift+Del",
    DELETE_FROM_MAP: "Удалить с карты",
    DELETE_FROM_MAP_HINT: "Del",
    ZOOM: "Масштаб",
    ADD_LOCATION_POINT_ON_GRAPH: "Добавить геопозицию"
};
